import { IUpdateLicense } from "../UpdateLicense/interface";
import "./SiteConfig.scss";
const SiteConfig = (props: IUpdateLicense) => {
    const { onClose, onSubmit } = props;
    return (
        <>
            <div className="modal-body px-2 py-3 events-none" >
                <div className="form-group">
                    <form>
                        <h6>Select file</h6>
                        <input type="file" id="conf" name="conf" accept=".conf" />
                    </form>
                </div>
            </div>
            <div className="no-border-footer modal-footer justify-content-center" >
                <div className="dis">
                    <button attr-test="modal-submit" type="button" className="btn btn-secondary footer-button mr-2 set-qc-button" onClick={() => onClose && onClose(false)}>Cancel</button>
                    <button attr-test="modal-submit" type="button" className="btn btn-primary footer-button set-qc-button" >Upload</button>
                </div>
            </div>
        </>
    )
}
export default SiteConfig;